module.exports = require('./register')().Promise



//////////////////
// WEBPACK FOOTER
// ./~/any-promise/index.js
// module id = 332
// module chunks = 0 1